import { connect } from 'react-redux';
import Program from '../../components/program/Program';
import * as actions from '../../actions/program';

const mapStateToProps = ({ program }) => ({
  programs: program.programs,
});

const mapDispatchToProps = dispatch => ({
  getPrograms: () => dispatch(actions.getPrograms()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Program);
